export default function nl2br (text) {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
}